export var StringsES = {
    // Registration and authentication processes
    authentication: {
        register_success: 'Verifique su correo electrónico utilizando el enlace que te hemos enviado',
        error_emailNotVerified: 'El correo no ha sido verificado',
        resetPasswordemail_sent: 'Se ha enviado un correo a ',
        resetPasswordemail_emailNotFound: 'No se encuentra el usuario',
        resetPasswordemail_unknownError: 'Error desconocido, intentelo más tarde o contacte con soporte',
        resetPasswordemail_required: 'Es necesario restaurar la contraseña',
    },
    // Popups
    popups: {
        input_box_label_user: 'Usuario',
        input_box_label_password: 'Contraseña',
        resetPasswordPopup_title: 'Restablecer contraseña',
        title_verifyemail: 'Email no verificado',
        text_verifyEmail: '¿Enviar correo de verificación a ',
        title_badlyAnonymizedDcm: 'Campos incompletos en los archivos DICOM',
        text_badlyAnonymizedDcm: 'Esto puede causar errores. ¿Desea preservar los archivos incompletos?',
        title_nonDcmFiles: 'No se han encontrado archivos DICOM compatibles',
        text_nonDcmFiles: 'FocusedON no puede cargar los archivos seleccionados',
        title_saveChanges: 'Hay cambios sin guardar',
        text_saveChanges: '¿Desea guardarlos?',
        title_unavailable: 'Mantenimiento en curso',
        text_unavailable: 'Funcionalidad temporalmente no disponible',
        title_setPatientId: 'Los archivos DICOM han sido anonimizados. Especifique nuevos identificadores para los resultados:',
        input_box_label_patientId: 'ID del paciente',
        input_box_label_studyId: 'ID del estudio',
        title_useForTraining: 'Decisión voluntaria',
        text_useForTraining: '¿Desea que las modificaciones realizadas sean empleadas para entrenar la inteligencia artificial?',
        title_setFileName: 'Especifique el nombre con el que se guardará el proyecto:',
        input_box_label_fileName: 'Nombre del archivo',
        title_idToken: 'Error',
        text_idToken: 'No ha sido posible obtener autorización',
    },
    // Modify popup
    modifyPopupStrings: {
        huVisualizationRange_title: 'Rango de visualización (UH)',
        sliceIndexes_title: 'Imágenes', // Rango de imágenes',
        sliceIndexes_current: 'Imagen:',
        huAssistance_title: 'Asistencia por UH',
        huAssistance_range: 'Rango de UH:',
    },
    // Buttons
    buttons: {
        button_back: 'Volver',
        button_login: 'Entrar',
        button_accept: 'Aceptar',
        button_cancel: 'Cancelar',
        button_resetPassword: 'Restablecer contraseña',
        button_logout: 'Salir',
        button_settings: 'Configuración',
        button_save: 'Guardar',
        button_exit: 'Salir',
        button_loginGoogle: 'Entrar con Google',
    },
    // Errors
    errors: {
        // Login errros 
        login_error_email_or_passowrd: 'Error en el correo o la contraseña',
        // Format (according to validators for one specific field)
        format_error_email: 'Formato del correo erroneo',
        format_error_password: 'Formato de la contraseña erroneo',
        // Format (generic validators)
        error_maxValue: 'Valor demasiado grande',
        error_minValue: 'Valor demasiado pequeño',
        error_step: 'Resolución demasiado elevada',
        error_required: 'Campo obligatorio',
        error_maxLength: 'Demasiados caracteres',
        error_specialCharacters: 'Caracteres no permitidos',
        error_spacesInString: 'No puede contener espacios',
    },
    // FocusedON String
    fnStrings: {
        button_load: 'Abrir',
        button_loadDicom: 'Abrir DICOM',
        button_loadProject: 'Abrir Project',
        waitingMessage_Login: 'Verificando credenciales',
        waitingMessage_LoadDicom: 'Cargando archivos',
        waitingMessage_LoadSeries: 'Anonimizando y cargando imágenes',
        waitingMessage_ClassifyingData: 'Segmentando imagen',
        waitingMessage_GeneratingResults: 'Generando resultados',
        waitingMessage_ModifyingData: 'Actualizando segmentación',
        waitingMessage_SavingTrainingData: 'Guardando datos de entrenamiento',
        waitingMessage_DownloadingProject: 'Guardando proyecto',
        waitingMessage_UploadingProject: 'Cargando proyecto',
        button_selectPatient: 'Seleccionar paciente',
        button_selectStudy: 'Seleccionar estudio',
        button_selectSeries: 'Seleccionar serie',
        button_selectProcess: 'Seleccionar proceso',
        button_classify: 'Clasificar',
        button_choose: 'Seleccionar',
        button_modify: 'Modificar',
        button_data: 'Datos',
        button_vertebralLevels: 'Niveles vertebrales',
        button_artifactsRanges: 'Artefactos',
        button_overflowRanges: 'Overflow',
        button_download: 'Descargar',
        button_results: 'Resultados',
        button_downloadProject: 'Proyecto',
        button_zip: 'Resultados (.zip)',
        button_help_docs: 'Documentación',
        button_help_support: 'Soporte Técnico',
        //button_send: 'Enviar',
    },
    // User feedback strings
    feedbackStrings:{
        successfullySaved: 'Guardado correctamente',
        unlicensed: 'No tiene licencia para cargar el proyecto seleccionado. Contacte con soporte.',
        noRemainingAnalysis: 'No tiene análisis disponible. Contacte con soporte.',
        licenseExpired: 'Su licencia ha caducado. Contacte con soporte.',
        enoughOffsetImages: "No se han podido generar los resultados. No hay al menos ${0} imágenes por encima o por debajo del rango seleccionado."
    },
    // Available processes
    processesString: {
        vertebralLevels: 'Niveles vertebrales',
    },
    // Additional data popups
    additionalDataPopupsStrings: {
        // Vertebral levels
        slider_title_vertebral_levels: 'Niveles vertebrales',
        slider_title_image_quality: 'Calidad de la imagen',
        title_segmentationDifficulty: 'Dificultad de la segmentación L1-L5',
        //slider_title_segmentation_difficulty: 'Dificultad de la segmentación',
        slider_title_patient_orientation: 'Orientación del paciente',
        slide_toggle_booleans: ['No', 'Sí'],
        title_ivContrast: 'Contraste intravenoso',
        value_venous_ivContrast: 'Venoso',
        value_arterial_ivContrast: 'Arterial',
        title_oContrast: 'Contraste oral',
        list_options_oContrast: ['Esófago y estómago', 'Intestino delgado', 'Intestino grueso y colon ascendente', 'Colon'],
        title_nArtifactRanges: 'Rangos con artefactos',
        title_nOverflowRanges: 'Rangos con overflow'
    },
    // Spreadsheets page
    spreadsheetsPageStrings : {
        box_top_message_title: 'Generación automática de hojas de cálculo para estudios clínicos con FocusedON',
        box_top_message_list: [
            'Los pacientes aparecerán ordenados en filas de acuerdo con su identificador (Patient ID) y la fecha de adquisición de los datos (Study date)',
            'Los campos Patient ID y Study date se colocarán en las primeras columnas de la hoja de cálculo generada',
            'El usuario debe seleccionar el resto de campos a incluir en la hoja de cálculo generada',
        ],
        list_title_available_fields: 'Campos disponibles',
        list_title_selected_fields: 'Campos seleccionados',
        button_select_files: 'Seleccione archivos a procesar',
        waitingMessage_GeneratingFile: 'Generando archivo de resultados',
    },
    // Landing page strings
    landingPageStrings : {
        button_statistics_title: 'Estadísticas',
        button_focusedon_title: 'FocusedON',
        button_statistics_text: 'Combinar resultados en un solo archivo',
        button_focusedon_text: 'Analizar imágenes DICOM usando IA',
    }

}